import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar,
  Rating,
  Divider,
  Button,
  styled,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const HealthDetailMobile = () => {
  const doctor = {
    name: 'Ember Wynn',
    specialty: 'Pediatric Neurology',
    profession: 'Pediatrician',
    hospital: 'National Hospital ABUJA',
    rating: 5.0,
    reviews: 20,
    image: 'https://via.placeholder.com/150/123456', // Placeholder image
    about:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, nulla a accumsan at morbi bibendum tortor id a. Nullam amet, ultricies orci ultrices odio condimentum.',
    workingHours: 'Monday - Friday 9:00AM - 2:00 PM',
    lastLogin: 'Tuesday, April 8, 2025',
    email: 'Emberwyn45@NHAhospital.com',
    phone: '+23481-785-253',
  };

  return (
    <Box sx={{ maxWidth: 'sm', margin: '0 auto', height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="back">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center' }}>
            {doctor.name}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, flexGrow: 1, overflowY: 'auto' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, border: '1px solid #ccc', borderRadius: 2, p: 2 }}>
          <Avatar src={doctor.image} alt={doctor.name} sx={{ width: 80, height: 80, mr: 2 }} />
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">{doctor.name}</Typography>
            <Typography variant="caption" color="text.secondary">{doctor.specialty}</Typography>
            <Typography variant="caption" color="text.secondary">{doctor.profession} | {doctor.hospital}</Typography>
            <Rating name="doctor-rating" value={doctor.rating} readOnly size="small" />
            <Typography variant="caption" color="text.secondary">({doctor.reviews} reviews)</Typography>
          </Box>
        </Box>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          About Dr. {doctor.name.split(' ')[1]}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {doctor.about}
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Working Hours
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {doctor.workingHours}
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Last Login
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {doctor.lastLogin}
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Contact Details
        </Typography>
        <List>
          <ListItem disablePadding>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: 'primary.light' }}>
                <EmailIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={doctor.email} />
          </ListItem>
          <ListItem disablePadding>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: 'success.light' }}>
                <PhoneIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={doctor.phone} />
          </ListItem>
        </List>

        <Button variant="contained" color="success" fullWidth sx={{ mt: 4 }}>
          Book Appointment
        </Button>

        <Typography variant="caption" color="text.secondary" align="center" sx={{ mt: 2 }}>
          Rate your experience with Doctor {doctor.name.split(' ')[1]}
        </Typography>
        {/* Implement rating component here if needed */}
      </Box>
    </Box>
  );
};

export default HealthDetailMobile;
